<template>
  <div :class="{ 'h5-course-card': isH5, 'pc-course-card': !isH5 }">
    <div class="cover-img-wrap">
      <div
        v-if="!isH5 && canTrialLseeon.id && productInfo.enrollment === null"
        class="can-trial"
      >
        <button @click="jumpCanTrialLesson" class="trial-btn">
          <img src="../../../assets/images/course-card/play-icon.png" />
          <span>免费试学</span>
        </button>
      </div>
      <img
        v-if="productInfo.cover_url"
        class="cover"
        :src="productInfo.cover_url + '?imageView2/0/w/700'"
        alt="课程图片"
      />
    </div>
    <div class="info-wrap">
      <!-- 固定信息 -->
      <div>
        <!-- 标题 -->
        <div class="title-wrap">
          <p class="title">
            {{ productInfo.course_name }}
          </p>
          <button
            @click="shareInApp"
            slot="reference"
            class="share-icon"
            v-preventReClick
            v-if="isHXApp"
          >
            <img src="../../../assets/images/share-icon.png" alt="" />
          </button>
          <el-popover
            v-else
            placement="bottom-start"
            trigger="click"
            popper-class="share-popover"
            @after-leave="selectShare = {}"
            @show="onShowSharePopover"
          >
            <button
              slot="reference"
              class="share-icon"
              v-preventReClick
              v-if="!isWeChat && !isQQ"
            >
              <img src="../../../assets/images/share-icon.png" alt="" />
            </button>
            <div class="share-box">
              <div class="share-list" v-if="!selectShare.type">
                <div class="share-item copy-item" @click="handleCopyPageUrl">
                  <img
                    src="../../../assets/images/product-details/link.png"
                    alt=""
                  />
                  <span>复制链接</span>
                </div>
                <div class="divider"></div>
                <div class="share-item" @click="handleShare('wechat')">
                  <img
                    src="../../../assets/images/product-details/wx.png"
                    alt=""
                  />
                  <span>微信</span>
                </div>
                <div class="share-item" @click="handleShare('circle')">
                  <img
                    src="../../../assets/images/product-details/wx-circle.png"
                    alt=""
                  />
                  <span>朋友圈</span>
                </div>
                <div class="share-item" @click="handleShare('QQ')">
                  <img
                    src="../../../assets/images/product-details/QQ.png"
                    alt=""
                  />
                  <span>QQ</span>
                </div>
                <div class="share-item" @click="handleShare('space')">
                  <img
                    src="../../../assets/images/product-details/QQ-space.png"
                    alt=""
                  />
                  <span>QQ空间</span>
                </div>
                <div class="share-item" @click="handleShare('weibo')">
                  <img
                    src="../../../assets/images/product-details/weibo.png"
                    alt=""
                  />
                  <span>微博</span>
                </div>
                <div class="share-item" @click="handleShare('xhs')" v-if="isH5">
                  <img
                    src="../../../assets/images/product-details/xhs.png"
                    alt=""
                  />
                  <span>小红书</span>
                </div>
              </div>
              <div class="share-content" v-else>
                <div class="title">
                  <img
                    src="../../../assets/images/product-details/back.png"
                    alt=""
                    @click="handleShareBack"
                  />
                  <span>分享到{{ selectShare.title }}</span>
                </div>
                <div class="qrcode-box">
                  <create-qr-code
                    ref="qrCode"
                    :url="courseDetailUrl"
                    :logo-url="logoUrl"
                    :canvas-width="140"
                    :canvas-height="140"
                    @create-qr-code="getQrCode"
                  />
                </div>
                <div class="tips">{{ selectShare.content }}</div>
              </div>
            </div>
          </el-popover>
        </div>
        <!-- tag -->
        <p
          class="tag-wrap"
          v-if="productInfo.goods && productInfo.goods.goods_tag"
        >
          <el-tag
            v-for="(item, index) in productInfo.goods.goods_tag.split(',')"
            :key="index"
            >{{ item }}</el-tag
          >
        </p>
        <template v-if="!isH5">
          <!-- 有效期 -->
          <p class="validity-period">
            课程有效期：<span class="info">{{
              productInfo.validityPeriod
            }}</span>
          </p>
          <!-- 数据信息 -->
          <div class="data-STATS">
            <span>{{ productInfo.lessonNum }}课时</span>
            <p
              class="STATS enrollment-count"
              v-if="
                productInfo.goods &&
                productInfo.goods.show_enrollment_count === 1
              "
            >
              <span class="separate"></span>
              <span>{{ million(productInfo.enrollment_count) }}人已学</span>
            </p>
          </div>
        </template>
      </div>

      <!-- 可变化部分 -->
      <div class="variable-cont-wrap">
        <!-- 促销 -->
        <promotion
          v-if="productInfo.activity_type === 2"
          :promotionInfo="productInfo.promotion_info"
          :originalPrice="productInfo.goods.price"
        />
        <!-- 拼团信息 -->
        <GroupInfo
          v-else-if="
            productInfo.group_set_info &&
            productInfo.group_set_info.activityStatus === 2
          "
          :groupSetInfo="productInfo.group_set_info"
        />
        <!-- 优惠券 -->
        <coupon
          @jumpLoginPage="jumpLoginPage"
          v-else-if="couponInfo.id"
          :couponInfo="couponInfo"
          @signUp="signUp"
          :hasGetcoupon="productInfo.has_get_coupon"
          :price="productInfo.goods.price"
        />
        <!-- 常规-价格 -->
        <div v-else class="normal-price-wrap">
          <!-- 价格 -->
          <p class="price-wrap" v-if="productInfo.goods">
            <span v-if="productInfo.goods.fee_type === 1" class="free"
              >免费</span
            >
            <!-- 促销价 -->
            <span
              v-else-if="productInfo.activity_type === 2"
              class="activity-price"
              >￥{{ productInfo.promotion_info.promotion_price / 100 }}</span
            >
            <span v-else class="price"
              ><i>￥</i>{{ productInfo.goods.price / 100 }}</span
            >
          </p>
        </div>
        <!-- 固定信息 -->
        <div v-if="isH5" class="bottom-wrap">
          <!-- 数据信息 -->
          <div class="data-STATS">
            <span>{{ productInfo.lessonNum }}课时</span>
            <p
              class="STATS enrollment-count"
              v-if="
                productInfo.goods &&
                productInfo.goods.show_enrollment_count === 1
              "
            >
              <span class="separate"></span>
              <span>{{ million(productInfo.enrollment_count) }}人已学</span>
            </p>
          </div>
          <!-- 有效期 -->
          <p class="validity-period">
            课程有效期：<span class="info">{{
              productInfo.validityPeriod
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <poster
      v-if="isAuthenticated"
      ref="poster"
      :course-info="productInfo"
      @getPosterUrl="getPosterUrl"
    />
  </div>
</template>

<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import coupon from "@saas/pages/src/product-details/components/coupon";
import promotion from "@saas/pages/src/product-details/components/promotion";
import GroupInfo from "@saas/pages/src/product-details/components/GroupInfo";
import {
  million,
  copyPageUrl,
  clipboard,
  isWeChat,
  isQQ,
  isHXApp,
} from "@saas/components/src/utils/utils";
import CreateQrCode from "@saas/components/src/components/CreateQrCode";
import Poster from "@saas/components/src/components/Poster";
import shareSdk from "@saas/components/src/utils/share";
export default {
  props: {
    couponInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    productInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isH5: {
      type: Boolean,
      default: false,
    },
    canTrialLseeon: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isHXApp: isHXApp(),
      million,
      copyPageUrl,
      isElectron: window.isElectron,
      selectShare: {
        type: "",
      },
      // courseDetailUrl:
      //   process.env.VUE_APP_SAAS_WEB_URL +
      //   "/product-detail/" +
      //   this.$route.params.id,
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      isShowShare: false,
      posterUrl: "",
      isWeChat: isWeChat(),
      isQQ: isQQ(),
    };
  },
  watch: {},
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    courseDetailUrl() {
      return (
        process.env.VUE_APP_SAAS_WEB_URL +
        "/product-detail/" +
        this.$route.params.id
      );
    },
  },
  mounted() {},
  methods: {
    shareInApp() {
      let { course_name, id, cover_url, goods = {} } = this.productInfo;
      jsToFlutter("shareAction", {
        courseName: course_name || "",
        courseUrl: `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${id}`,
        coverUrl: cover_url,
        courseId: id,
        postUrl: this.posterUrl || "",
        price: goods.price,
      });
    },
    onShowSharePopover() {
      if (!this.posterUrl) {
        this.$refs.poster.checkLoad();
      }
    },
    getPosterUrl(url) {
      this.posterUrl = url;
      console.log(url, "url==========");
    },
    handleCopyPageUrl() {
      if (window.isElectron) {
        let content = `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${this.productInfo.id}`;
        clipboard(content, () => {
          this.$showToast("已复制课程链接，粘贴即可分享");
          this.isShowShare = false;
        });
      } else {
        copyPageUrl();
        this.isShowShare = false;
      }
    },
    handleShare(type) {
      console.log(this.productInfo.cover_url);
      console.log(this.posterUrl);
      if (type === "wechat") {
        this.selectShare = {
          type: "wechat",
          title: "微信",
          content: "扫描二维码，将课程分享给微信好友吧。",
        };
      } else if (type === "QQ") {
        this.selectShare = {
          type: "QQ",
          title: "QQ",
          content: "扫描二维码，将课程分享给QQ好友吧。",
        };
      } else if (type === "space") {
        this.selectShare = {
          type: "space",
          title: "QQ空间",
          content: "扫描二维码，将课程分享到QQ空间吧。",
        };
      } else if (type === "circle") {
        this.selectShare = {
          type: "circle",
          title: "朋友圈",
          content: "扫描二维码，将课程分享到朋友圈吧。",
        };
      } else if (type === "weibo") {
        shareSdk("weibo", {
          url: this.courseDetailUrl, // 分享地址
          title: this.productInfo.course_name, // 分享标题
          pic: this.productInfo.cover_url,
        });
      } else if (type === "xhs") {
        if (!this.isAuthenticated) {
          this.$loginDialog();
        }
        if (!this.posterUrl) {
          this.$message.error("海报正在生成中，请稍后重试");
          return;
        }
        shareSdk("xhs", {
          shareInfo: {
            type: "normal", // 必填，笔记类型 'video' | 'normal'
            // title: "测试标题", // 笔记标题
            content: `速看！这门内容充实，讲解精彩的课程【${this.productInfo.course_name}】，可别错过了！扫描二维码，魔果云课看好课！`, // 笔记正文
            images: [this.posterUrl], // 图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文须是服务器地址，暂时不支持本地文件
          },
          fail: (e) => {
            console.log(e);
            // 调用失败时执行的回调函数
          },
        });
      }
    },
    getQrCode(url) {},
    handleShareBack() {
      this.selectShare = {
        type: "",
      };
    },
    signUp() {
      this.$emit("signUp");
    },
    jumpLoginPage() {
      this.$emit("jumpLoginPage");
    },
    jumpCanTrialLesson() {
      let { id, unit_id, course_id } = this.canTrialLseeon;
      if (this.isHXApp) {
        let params = {
          course_id,
          unit_id,
          lesson_id: id,
        };
        jsToFlutter("videoPlayer", params);
      } else {
        this.$router.push(`/video-play/${course_id}/${unit_id}/${id}`);
      }
    },
  },
  components: {
    GroupInfo,
    promotion,
    coupon,
    CreateQrCode,
    Poster,
  },
};
</script>

<style lang="scss" scoped>
.pc-course-card {
  background: #fff;
  border-radius: 24px 24px 0 0;
  padding: 16px 16px 0;
  display: flex;
  .title-wrap {
    display: flex;
    .share-icon {
      width: 18px;
      height: 25px;
      margin-left: 6px;
      img {
        height: 16px;
        width: 16px;
      }
    }
  }
  .cover-img-wrap {
    width: 400px;
    height: 225px;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    margin-right: 13px;
    .can-trial {
      position: absolute;
      background: rgba($color: #000000, $alpha: 0.2);
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .trial-btn {
      width: 102px;
      height: 30px;
      background: linear-gradient(
        133deg,
        #ff7a00 0%,
        #ff5037 37%,
        #ff2f9a 86%,
        #ff27c0 100%
      );
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 10px;
        height: 10px;
        margin-right: 4px;
      }
      span {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 22px;
        margin-right: 4px;
        margin-bottom: 1px;
      }
    }
  }
  .cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .info-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    height: 225px;
    .title {
      font-weight: 500;
      font-size: 18px;
      color: $saas-text-color;
      line-height: 25px;
      margin-bottom: 8px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      line-break: anywhere;
    }
    .tag-wrap .el-tag {
      font-weight: 400;
      font-size: 12px;
      color: #00cb9b;
      line-height: 21px;
      height: 21px;
      background: #ebfff6;
      border-radius: 6px;
      padding: 0 4px;
      margin-right: 4px;
      margin-bottom: 8px;
    }
    .data-STATS {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #747573;
      line-height: 20px;
      margin-bottom: 8px;
    }
    .separate {
      display: inline-block;
      width: 1px;
      height: 11px;
      background: #efefef;
      margin: 0 8px;
    }
    .validity-period {
      font-weight: 400;
      font-size: 14px;
      color: #747573;
      line-height: 20px;
      margin-bottom: 8px;
    }
  }
  .variable-cont-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .normal-price-wrap {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: 100%;
    }
  }
  .normal-price-wrap {
    .free,
    .price {
      font-weight: 600;
      font-size: 24px;
      i {
        font-size: 12px;
        font-style: normal;
      }
      color: #f03349;
    }
  }
}
.share-box {
  .share-list {
    padding: 9px 8px 5px 8px;
    .share-item {
      width: 174px;
      height: 38px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        background: #f6f8fc;
      }
      img {
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-right: 7px;
      }
      span {
        font-size: 14px;
        color: #0d1400;
        line-height: 20px;
      }
      &.copy {
      }
    }
    .divider {
      width: 173px;
      height: 1px;
      background: #f2f3f5;
      margin: 7px 0 3px 0;
    }
  }
  .share-content {
    width: 190px;
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 14px;
      margin-left: 19px;
      img {
        cursor: pointer;
        width: 6px;
        height: 9px;
        margin-right: 6px;
      }
      span {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
    }
    .qrcode-box {
      margin-top: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tips {
      padding: 0 13px 21px 16px;
      margin-top: 22px;
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      text-align: center;
    }
  }
}
.h5-course-card {
  background: #fff;
  padding: 0.13rem 0.31rem 0;
  .title-wrap {
    display: flex;
    .share-icon {
      width: 0.5rem;
      height: 0.6rem;
      margin-left: 0.2rem;
      img {
        height: 0.4rem;
        width: 0.4rem;
      }
    }
  }
  .cover {
    min-width: 100%;
    width: 9.41rem;
    height: 5.3rem;
    object-fit: cover;
    border-radius: 0.21rem;
    margin-bottom: 0.14rem;
  }
  .info-wrap {
    .title {
      margin-left: 0.15rem;
      margin-bottom: 0.21rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: $saas-text-color;
      line-height: 0.6rem;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      line-break: anywhere;
    }
    .tag-wrap {
      margin-left: 0.15rem;
    }
    .tag-wrap .el-tag {
      font-weight: 400;
      font-size: 0.32rem;
      color: #00cb9b;
      line-height: 0.56rem;
      height: 0.56rem;
      background: #ebfff6;
      border-radius: 0.16rem;
      padding: 0 0.11rem;
      margin-right: 0.11rem;
      margin-bottom: 0.21rem;
    }
    .data-STATS {
      display: flex;
      align-items: center;
      margin-left: 0.15rem;
      font-weight: 400;
      font-size: 0.29rem;
      color: #747573;
      line-height: 0.4rem;
      margin-bottom: 0.21rem;
    }
    .separate {
      display: inline-block;
      width: 0.01rem;
      height: 0.21rem;
      background: #efefef;
      margin: 0 0.11rem;
    }
    .validity-period {
      margin-left: 0.15rem;
      font-weight: 400;
      font-size: 0.29rem;
      color: #747573;
      line-height: 0.4rem;
      padding-bottom: 0.27rem;
    }
  }
  .normal-price-wrap {
    margin-left: 0.15rem;
    margin-bottom: 0.21rem;
    .free,
    .price {
      font-weight: 600;
      font-size: 0.61rem;
      i {
        font-size: 0.32rem;
        font-style: normal;
      }
      color: #f03349;
    }
  }
}
</style>
<style lang="scss">
.share-popover {
  padding: 0;
  border-radius: 12px;
}
</style>
